<p class="acctOperationPanel__trigger mb-0">
  <em>({{ triggerTypeName }})</em>:
  @switch (trigger.triggerType) {
    @case (0) {
      When a <strong>{{ anchorTemplateLabel }}</strong> or its Parent Installment record is associated to a
      <strong>{{
      accountingTemplateLabel }}</strong> Accounting template.
    }
    @case (1) {
      When <strong>{{ workflowActionLabel }}</strong> Workflow Action is taken on a <strong>{{
    anchorTemplateLabel }}</strong> or its Parent Installment record.
  }
  @case (2) {
    @if(cmd) {
      When <strong>{{ fieldLabel }}</strong> on @if (isTableCharTypeId) {
      parent
    }
    <strong>{{ dataBehaviorTemplateLabel }}</strong> {{ operatorLabel }}
    @switch (valueEntryType) {
      @case ('none') {
        <!-- EMPTY -->
      }
      @case ('single') {
        <strong class="ms-1">
          <rl-data-behavior-single-value-entry [editMode]="false" [control]="valueControl"
            [cmd]="cmd">
          </rl-data-behavior-single-value-entry>
        </strong>
      }
      @case ('range') {
        <div class="ms-1 d-inline-block">
          <strong class="ms-1">
            <rl-data-behavior-single-value-entry [editMode]="false" [control]="range1Control"
            [cmd]="cmd"></rl-data-behavior-single-value-entry>
          </strong>
          and
          <strong>
            <rl-data-behavior-single-value-entry [editMode]="false" [control]="range2Control"
            [cmd]="cmd"></rl-data-behavior-single-value-entry>
          </strong>
        </div>
      }
    }
    .
  } @else {
    <span class="text-danger"><strong>Trigger Broken:</strong> Unable to find field
    {{ trigger.characteristicId }} on
  template {{ trigger.templateId }}.</span>
}
}
<!-- Record Creation -->
@case (3) {
  When a <strong>{{ amountTemplateLabel }}</strong> is created on a <strong>{{ tableTemplateLabel }}</strong>
}
@default {
  <em>Unknown Trigger Type</em>
}
}
</p>